// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"383143b2","229":"3743283b","282":"a54dde20","325":"56f41f5d","389":"89e59814","498":"701564e2","660":"bc09c637","750":"e817b141"}[chunkId] + ".chunk.js";
};